import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

/**
 * Aktif hastane adreslerini getirir.
 * Vaka formu autocomplete'i ve yönetim sayfası tarafından kullanılır.
 */
export function useHospitalAddresses() {
  return useQuery({
    queryKey: ['hospital-addresses'],
    queryFn: () => api.get('/lookups/addresses').then(r => r.data.data || []),
    staleTime: 5 * 60 * 1000,
    placeholderData: [],
  });
}

/**
 * Aktif sevk türlerini getirir.
 * Vaka detay formu ve yönetim sayfası tarafından kullanılır.
 */
export function useTransportTypes() {
  return useQuery({
    queryKey: ['transport-types'],
    queryFn: () => api.get('/lookups/transport-types').then(r => r.data.data || []),
    staleTime: 5 * 60 * 1000,
    placeholderData: [],
  });
}
